import { PrimaryButton, MessageBar, MessageBarType, Text, Stack, StackItem, type IStackTokens } from '@fluentui/react';
import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import campusIcon from 'media/img/campusIcon.png';
import campusLogo from 'media/img/ivcampus-logo.svg';
import IvicosStrings from 'kits/language/stringKit';

const stackTokens: IStackTokens = {
    childrenGap: 20,
    padding: 20
};

const containerStyles = {
    root: {
        backgroundColor: '#e4e4e3',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        justifyContent: 'center'
    }
};

const cardStyles = {
    root: {
        height: navigator.language === 'de' ? 360 : 325,
        width: 425,
        backgroundColor: '#fff',
        boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)'
    }
};

const ResetWizard: React.FC = (): JSX.Element => {
    const [resetComplete, setResetComplete] = useState(false);
    const navigate = useNavigate();

    const clearCaches = async () => {
        if (!('caches' in window)) return;
        const keyList = await caches.keys();
        await Promise.allSettled(keyList.map((key) => caches.delete(key)));
    };

    const handleReset = useCallback(async () => {
        try {
            localStorage.clear();
            sessionStorage.clear();
            await clearCaches();
            setResetComplete(true);
        } catch (error) {
            console.error('Reset failed:', error);
        }
    }, []);

    useEffect(() => {
        let timeoutId: number;
        if (resetComplete) {
            timeoutId = window.setTimeout(() => {
                navigate('/login');
                setResetComplete(false);
            }, 2000);
        }
        return () => clearTimeout(timeoutId);
    }, [resetComplete]);

    return (
        <Stack horizontalAlign="center" styles={containerStyles}>
            <Stack style={{ marginTop: -40, marginBottom: 53, width: 375, height: 73 }}>
                <img src={campusLogo} alt="logo" />
            </Stack>

            <Stack style={{ marginBottom: -50, zIndex: 10 }}>
                <img src={campusIcon} alt="campus icon" width={91.56} />
            </Stack>

            <Stack horizontalAlign="center" tokens={stackTokens} styles={cardStyles}>
                <StackItem style={{ marginTop: 50 }}>
                    <Text variant="xLarge" style={{ fontWeight: 'bold' }}>
                        {IvicosStrings.resetWizard.title}
                    </Text>
                </StackItem>

                <Stack tokens={{ childrenGap: 20 }} horizontalAlign="center" verticalAlign="center">
                    <StackItem>
                        <Text>{IvicosStrings.resetWizard.description1}</Text>
                        <br />
                        <br />
                        <Text>{IvicosStrings.resetWizard.description2}</Text>
                    </StackItem>

                    {resetComplete ? (
                        <StackItem>
                            <MessageBar aria-live="polite" messageBarType={MessageBarType.success} dismissButtonAriaLabel="Close">
                                {IvicosStrings.resetWizard.resetComplete}
                            </MessageBar>
                        </StackItem>
                    ) : (
                        <StackItem aria-label="reset-button">
                            <PrimaryButton
                                text={IvicosStrings.resetWizard.reset}
                                onClick={handleReset}
                                styles={{
                                    root: { padding: '20px 40px', height: 'auto' },
                                    label: { fontSize: '16px' }
                                }}
                            />
                        </StackItem>
                    )}
                </Stack>
            </Stack>
        </Stack>
    );
};

export default ResetWizard;
